import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const SubDepartmentApi = createApi({
  reducerPath: "SubDepartmentApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    //Start Sub Department API's-------------------------------------------
    getAllSubDepartmentData: builder.query({
      query: () => "get_all_sub_departments",
      transformResponse: (response) => response.data || [],
    }),
    addSubDepartment: builder.mutation({
      query: (addsub) => ({
        url: "add_sub_department",
        method: "POST",
        body: addsub,
      }),
    }),
    editSubDepartment: builder.mutation({
      query: (editsub) => ({
        url: `update_sub_department`,
        method: "PUT",
        body: editsub,
      }),
    }),

    getSubDepSingletById: builder.query({
      query: ({ id }) => `get_subdept_from_id/${id}`,
      transformResponse: (response) => response || [],
    }),

    deleteSubDepartment: builder.mutation({
      query: (id) => ({
        url: `delete_sub_department/${id}`,
        method: "DELETE",
      }),
    }),

    //END Sub Department API's-------------------------------------------
  }),
});

export const {
  //sub department api
  useGetAllSubDepartmentDataQuery,
  useAddSubDepartmentMutation,
  useEditSubDepartmentMutation,
  useGetSubDepSingletByIdQuery,
  useDeleteSubDepartmentMutation,
} = SubDepartmentApi;

export default SubDepartmentApi;
